module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginForm modal fade",
    attrs: {
      "id": "printerInfoModal"
    }
  }, [_c('row', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('column', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('column', {
    staticClass: "col-md-10"
  }, [_c('va-box', {
    attrs: {
      "title": _vm.title,
      "theme": "box-info",
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.printerInfo), function(item) {
    return _c('div', {
      staticClass: "col-sm-3"
    }, [_c('div', {
      staticClass: "description-block",
      staticStyle: {
        "background-color": "#eee",
        "padding": "5px",
        "height": "50px"
      }
    }, [_c('div', {
      staticClass: "description-text text-left"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('h6', {
      staticClass: "description-header"
    }, [_vm._v(_vm._s(item.value))])])])
  }), 0), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('va-button', {
    attrs: {
      "isBlock": false,
      "theme": "danger",
      "name": "Close",
      "align": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    }
  })], 1)])], 1), _vm._v(" "), _c('column', {
    staticClass: "col-md-1"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8c3829a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrinterInfo.vue
// module id = 734
// module chunks = 0